var items = {
  "block.minecraft.air": "ɹᴉɐ",
  "block.minecraft.stone": "ǝuoʇs",
  "block.minecraft.granite": "ǝʇᴉuɐɹ⅁",
  "block.minecraft.polished_granite": "ǝʇᴉuɐɹ⅁ pǝɥsᴉꞁoԁ",
  "block.minecraft.diorite": "ǝʇᴉɹoᴉᗡ",
  "block.minecraft.polished_diorite": "ǝʇᴉɹoᴉᗡ pǝɥsᴉꞁoԁ",
  "block.minecraft.andesite": "ǝʇᴉsǝpuɐ",
  "block.minecraft.polished_andesite": "ǝʇᴉsǝpuɐ pǝɥsᴉꞁoԁ",
  "block.minecraft.grass_block": "ʞɔoꞁᗺ ssɐɹ⅁",
  "block.minecraft.dirt": "ʇɹᴉᗡ",
  "block.minecraft.coarse_dirt": "ʇɹᴉᗡ ǝsɹɐoɔ",
  "block.minecraft.podzol": "ꞁozpoԁ",
  "block.minecraft.crimson_nylium": "ɯnᴉꞁʎn uosɯᴉɹɔ",
  "block.minecraft.warped_nylium": "ɯnᴉꞁʎn pǝdɹɐm",
  "block.minecraft.cobblestone": "ǝuoʇsǝꞁqqoɔ",
  "block.minecraft.oak_planks": "sʞuɐꞁԁ ʞɐo",
  "block.minecraft.spruce_planks": "sʞuɐꞁԁ ǝɔnɹds",
  "block.minecraft.birch_planks": "sʞuɐꞁԁ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_planks": "sʞuɐꞁԁ ǝꞁᵷunր",
  "block.minecraft.acacia_planks": "sʞuɐꞁԁ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_planks": "sʞuɐꞁԁ ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_planks": "sʞuɐꞁԁ uosɯᴉɹɔ",
  "block.minecraft.warped_planks": "sʞuɐꞁԁ pǝdɹɐm",
  "block.minecraft.oak_sapling": "ᵷuᴉꞁdɐs ʞɐo",
  "block.minecraft.spruce_sapling": "ᵷuᴉꞁdɐs ǝɔnɹds",
  "block.minecraft.birch_sapling": "ᵷuᴉꞁdɐs ɥɔɹᴉᗺ",
  "block.minecraft.jungle_sapling": "ᵷuᴉꞁdɐs ǝꞁᵷunր",
  "block.minecraft.acacia_sapling": "ᵷuᴉꞁdɐs ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_sapling": "ᵷuᴉꞁdɐs ʞɐo ʞɹɐᗡ",
  "block.minecraft.bedrock": "ʞɔoɹpǝᗺ",
  "block.minecraft.sand": "puɐs",
  "block.minecraft.red_sand": "puɐs pǝᴚ",
  "block.minecraft.gravel": "ꞁǝʌɐɹ⅁",
  "block.minecraft.gold_ore": "ǝɹo pꞁo⅁",
  "block.minecraft.iron_ore": "ǝɹo uoɹi",
  "block.minecraft.coal_ore": "ǝɹo ꞁɐoɔ",
  "block.minecraft.nether_gold_ore": "ǝɹo pꞁo⅁ ɹǝɥʇǝn",
  "block.minecraft.oak_log": "ᵷoꞁ ʞɐo",
  "block.minecraft.spruce_log": "ᵷoꞁ ǝɔnɹds",
  "block.minecraft.birch_log": "ᵷoꞁ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_log": "ᵷoꞁ ǝꞁᵷunր",
  "block.minecraft.acacia_log": "ᵷoꞁ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_log": "ᵷoꞁ ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_stem": "ɯǝʇs uosɯᴉɹɔ",
  "block.minecraft.warped_stem": "ɯǝʇs pǝdɹɐm",
  "block.minecraft.stripped_oak_log": "ᵷoꞁ ʞɐo pǝddᴉɹʇs",
  "block.minecraft.stripped_spruce_log": "ᵷoꞁ ǝɔnɹds pǝddᴉɹʇs",
  "block.minecraft.stripped_birch_log": "ᵷoꞁ ɥɔɹᴉᗺ pǝddᴉɹʇs",
  "block.minecraft.stripped_jungle_log": "ᵷoꞁ ǝꞁᵷunր pǝddᴉɹʇs",
  "block.minecraft.stripped_acacia_log": "ᵷoꞁ ɐᴉɔɐɔɐ pǝddᴉɹʇs",
  "block.minecraft.stripped_dark_oak_log": "ᵷoꞁ ʞɐo ʞɹɐᗡ pǝddᴉɹʇs",
  "block.minecraft.stripped_crimson_stem": "ɯǝʇs uosɯᴉɹɔ pǝddᴉɹʇs",
  "block.minecraft.stripped_warped_stem": "ɯǝʇs pǝdɹɐm pǝddᴉɹʇs",
  "block.minecraft.stripped_oak_wood": "poom ʞɐo pǝddᴉɹʇs",
  "block.minecraft.stripped_spruce_wood": "poom ǝɔnɹds pǝddᴉɹʇs",
  "block.minecraft.stripped_birch_wood": "poom ɥɔɹᴉᗺ pǝddᴉɹʇs",
  "block.minecraft.stripped_jungle_wood": "poom ǝꞁᵷunր pǝddᴉɹʇs",
  "block.minecraft.stripped_acacia_wood": "poom ɐᴉɔɐɔɐ pǝddᴉɹʇs",
  "block.minecraft.stripped_dark_oak_wood": "poom ʞɐo ʞɹɐᗡ pǝddᴉɹʇs",
  "block.minecraft.stripped_crimson_hyphae": "ǝɐɥdʎh uosɯᴉɹɔ pǝddᴉɹʇs",
  "block.minecraft.stripped_warped_hyphae": "ǝɐɥdʎh pǝdɹɐm pǝddᴉɹʇs",
  "block.minecraft.oak_wood": "poom ʞɐo",
  "block.minecraft.spruce_wood": "poom ǝɔnɹds",
  "block.minecraft.birch_wood": "poom ɥɔɹᴉᗺ",
  "block.minecraft.jungle_wood": "poom ǝꞁᵷunր",
  "block.minecraft.acacia_wood": "poom ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_wood": "poom ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_hyphae": "ǝɐɥdʎh uosɯᴉɹɔ",
  "block.minecraft.warped_hyphae": "ǝɐɥdʎh pǝdɹɐm",
  "block.minecraft.oak_leaves": "sǝʌɐǝꞁ ʞɐo",
  "block.minecraft.spruce_leaves": "sǝʌɐǝꞁ ǝɔnɹds",
  "block.minecraft.birch_leaves": "sǝʌɐǝꞁ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_leaves": "sǝʌɐǝꞁ ǝꞁᵷunր",
  "block.minecraft.acacia_leaves": "sǝʌɐǝꞁ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_leaves": "sǝʌɐǝꞁ ʞɐo ʞɹɐᗡ",
  "block.minecraft.sponge": "ǝᵷuods",
  "block.minecraft.wet_sponge": "ǝᵷuods ʇǝm",
  "block.minecraft.glass": "ssɐꞁ⅁",
  "block.minecraft.lapis_ore": "ǝɹo ᴉꞁnzɐꞁ sᴉdɐꞁ",
  "block.minecraft.lapis_block": "ʞɔoꞁᗺ ᴉꞁnzɐꞁ sᴉdɐꞁ",
  "block.minecraft.dispenser": "ɹǝsuǝdsᴉᗡ",
  "block.minecraft.sandstone": "ǝuoʇspuɐs",
  "block.minecraft.chiseled_sandstone": "ǝuoʇspuɐs pǝꞁꞁǝsᴉɥɔ",
  "block.minecraft.cut_sandstone": "ǝuoʇspuɐs ʇnɔ",
  "block.minecraft.note_block": "ʞɔoꞁᗺ ǝʇon",
  "block.minecraft.powered_rail": "ꞁᴉɐᴚ pǝɹǝʍoԁ",
  "block.minecraft.detector_rail": "ꞁᴉɐᴚ ɹoʇɔǝʇǝᗡ",
  "block.minecraft.sticky_piston": "uoʇsᴉԁ ʎʞɔᴉʇs",
  "block.minecraft.cobweb": "qǝʍqoɔ",
  "block.minecraft.grass": "ssɐɹ⅁",
  "block.minecraft.fern": "uɹǝⅎ",
  "block.minecraft.dead_bush": "ɥsnᗺ pɐǝᗡ",
  "block.minecraft.seagrass": "ssɐɹᵷɐǝs",
  "block.minecraft.sea_pickle": "ǝꞁʞɔᴉԁ ɐǝs",
  "block.minecraft.piston": "uoʇsᴉԁ",
  "block.minecraft.white_wool": "ꞁoom ǝʇᴉɥm",
  "block.minecraft.orange_wool": "ꞁoom ǝᵷuɐɹo",
  "block.minecraft.magenta_wool": "ꞁoom ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_wool": "ꞁoom ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_wool": "ꞁoom ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_wool": "ꞁoom ǝɯᴉꞁ",
  "block.minecraft.pink_wool": "ꞁoom ʞuᴉԁ",
  "block.minecraft.gray_wool": "ꞁoom ʎǝɹ⅁",
  "block.minecraft.light_gray_wool": "ꞁoom ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_wool": "ꞁoom uɐʎɔ",
  "block.minecraft.purple_wool": "ꞁoom ǝꞁdɹnԁ",
  "block.minecraft.blue_wool": "ꞁoom ǝnꞁᗺ",
  "block.minecraft.brown_wool": "ꞁoom uʍoɹᗺ",
  "block.minecraft.green_wool": "ꞁoom uǝǝɹ⅁",
  "block.minecraft.red_wool": "ꞁoom pǝᴚ",
  "block.minecraft.black_wool": "ꞁoom ʞɔɐꞁᗺ",
  "block.minecraft.dandelion": "uoᴉꞁǝpuɐᗡ",
  "block.minecraft.poppy": "ʎddoԁ",
  "block.minecraft.blue_orchid": "pᴉɥɔɹo ǝnꞁᗺ",
  "block.minecraft.allium": "ɯnᴉꞁꞁɐ",
  "block.minecraft.azure_bluet": "ʇǝnꞁᗺ ǝɹnzɐ",
  "block.minecraft.red_tulip": "dᴉꞁn⟘ pǝᴚ",
  "block.minecraft.orange_tulip": "dᴉꞁn⟘ ǝᵷuɐɹo",
  "block.minecraft.white_tulip": "dᴉꞁn⟘ ǝʇᴉɥm",
  "block.minecraft.pink_tulip": "dᴉꞁn⟘ ʞuᴉԁ",
  "block.minecraft.oxeye_daisy": "ʎsᴉɐᗡ ǝʎǝxo",
  "block.minecraft.cornflower": "ɹǝʍoꞁɟuɹoɔ",
  "block.minecraft.lily_of_the_valley": "ʎǝꞁꞁɐλ ǝɥʇ ɟo ʎꞁᴉꞁ",
  "block.minecraft.wither_rose": "ǝsoᴚ ɹǝɥʇᴉm",
  "block.minecraft.brown_mushroom": "ɯooɹɥsnw uʍoɹᗺ",
  "block.minecraft.red_mushroom": "ɯooɹɥsnw pǝᴚ",
  "block.minecraft.crimson_fungus": "snᵷunⅎ uosɯᴉɹɔ",
  "block.minecraft.warped_fungus": "snᵷunⅎ pǝdɹɐm",
  "block.minecraft.crimson_roots": "sʇooᴚ uosɯᴉɹɔ",
  "block.minecraft.warped_roots": "sʇooᴚ pǝdɹɐm",
  "block.minecraft.nether_sprouts": "sʇnoɹds ɹǝɥʇǝn",
  "block.minecraft.weeping_vines": "sǝuᴉʌ ᵷuᴉdǝǝm",
  "block.minecraft.twisting_vines": "sǝuᴉʌ ᵷuᴉʇsᴉʍ⟘",
  "block.minecraft.sugar_cane": "ǝuɐɔ ɹɐᵷns",
  "block.minecraft.kelp": "dꞁǝʞ",
  "block.minecraft.bamboo": "ooqɯɐᗺ",
  "block.minecraft.gold_block": "ʞɔoꞁᗺ pꞁo⅁",
  "block.minecraft.iron_block": "ʞɔoꞁᗺ uoɹi",
  "block.minecraft.oak_slab": "qɐꞁs ʞɐo",
  "block.minecraft.spruce_slab": "qɐꞁs ǝɔnɹds",
  "block.minecraft.birch_slab": "qɐꞁs ɥɔɹᴉᗺ",
  "block.minecraft.jungle_slab": "qɐꞁs ǝꞁᵷunր",
  "block.minecraft.acacia_slab": "qɐꞁs ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_slab": "qɐꞁs ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_slab": "qɐꞁs uosɯᴉɹɔ",
  "block.minecraft.warped_slab": "qɐꞁs pǝdɹɐm",
  "block.minecraft.stone_slab": "qɐꞁs ǝuoʇs",
  "block.minecraft.smooth_stone_slab": "qɐꞁs ǝuoʇs ɥʇooɯs",
  "block.minecraft.sandstone_slab": "qɐꞁs ǝuoʇspuɐs",
  "block.minecraft.cut_sandstone_slab": "qɐꞁs ǝuoʇspuɐs ʇnɔ",
  "block.minecraft.petrified_oak_slab": "qɐꞁs ʞɐo pǝᴉɟᴉɹʇǝԁ",
  "block.minecraft.cobblestone_slab": "qɐꞁs ǝuoʇsǝꞁqqoɔ",
  "block.minecraft.brick_slab": "qɐꞁs ʞɔᴉɹᗺ",
  "block.minecraft.stone_brick_slab": "qɐꞁs ʞɔᴉɹᗺ ǝuoʇs",
  "block.minecraft.nether_brick_slab": "qɐꞁs ʞɔᴉɹᗺ ɹǝɥʇǝn",
  "block.minecraft.quartz_slab": "qɐꞁs zʇɹɐnꝺ",
  "block.minecraft.red_sandstone_slab": "qɐꞁs ǝuoʇspuɐs pǝᴚ",
  "block.minecraft.cut_red_sandstone_slab": "qɐꞁs ǝuoʇspuɐs pǝᴚ ʇnɔ",
  "block.minecraft.purpur_slab": "qɐꞁs ɹndɹnԁ",
  "block.minecraft.prismarine_slab": "qɐꞁs ǝuᴉɹɐɯsᴉɹԁ",
  "block.minecraft.prismarine_brick_slab": "qɐꞁs ʞɔᴉɹᗺ ǝuᴉɹɐɯsᴉɹԁ",
  "block.minecraft.dark_prismarine_slab": "qɐꞁs ǝuᴉɹɐɯsᴉɹԁ ʞɹɐᗡ",
  "block.minecraft.smooth_quartz": "ʞɔoꞁᗺ zʇɹɐnꝺ ɥʇooɯs",
  "block.minecraft.smooth_red_sandstone": "ǝuoʇspuɐs pǝᴚ ɥʇooɯs",
  "block.minecraft.smooth_sandstone": "ǝuoʇspuɐs ɥʇooɯs",
  "block.minecraft.smooth_stone": "ǝuoʇs ɥʇooɯs",
  "block.minecraft.bricks": "sʞɔᴉɹᗺ",
  "block.minecraft.tnt": "⟘n⟘",
  "block.minecraft.bookshelf": "ɟꞁǝɥsʞooᗺ",
  "block.minecraft.mossy_cobblestone": "ǝuoʇsǝꞁqqoɔ ʎssow",
  "block.minecraft.obsidian": "uɐᴉpᴉsqo",
  "block.minecraft.torch": "ɥɔɹo⟘",
  "block.minecraft.end_rod": "poᴚ puǝ",
  "block.minecraft.chorus_plant": "ʇuɐꞁԁ snɹoɥɔ",
  "block.minecraft.chorus_flower": "ɹǝʍoꞁⅎ snɹoɥɔ",
  "block.minecraft.purpur_block": "ʞɔoꞁᗺ ɹndɹnԁ",
  "block.minecraft.purpur_pillar": "ɹɐꞁꞁᴉԁ ɹndɹnԁ",
  "block.minecraft.purpur_stairs": "sɹᴉɐʇs ɹndɹnԁ",
  "block.minecraft.spawner": "ɹǝuʍɐds",
  "block.minecraft.oak_stairs": "sɹᴉɐʇs ʞɐo",
  "block.minecraft.chest": "ʇsǝɥɔ",
  "block.minecraft.diamond_ore": "ǝɹo puoɯɐᴉᗡ",
  "block.minecraft.diamond_block": "ʞɔoꞁᗺ puoɯɐᴉᗡ",
  "block.minecraft.crafting_table": "ǝꞁqɐ⟘ ᵷuᴉʇɟɐɹɔ",
  "block.minecraft.farmland": "puɐꞁɯɹɐⅎ",
  "block.minecraft.furnace": "ǝɔɐuɹnⅎ",
  "block.minecraft.ladder": "ɹǝppɐꞁ",
  "block.minecraft.rail": "ꞁᴉɐᴚ",
  "block.minecraft.cobblestone_stairs": "sɹᴉɐʇs ǝuoʇsǝꞁqqoɔ",
  "block.minecraft.lever": "ɹǝʌǝꞁ",
  "block.minecraft.stone_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ ǝuoʇs",
  "block.minecraft.oak_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ ʞɐo",
  "block.minecraft.spruce_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ ǝɔnɹds",
  "block.minecraft.birch_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ ǝꞁᵷunր",
  "block.minecraft.acacia_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ uosɯᴉɹɔ",
  "block.minecraft.warped_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ pǝdɹɐm",
  "block.minecraft.polished_blackstone_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.redstone_ore": "ǝɹo ǝuoʇspǝᴚ",
  "block.minecraft.redstone_torch": "ɥɔɹo⟘ ǝuoʇspǝᴚ",
  "block.minecraft.snow": "ʍous",
  "block.minecraft.ice": "ǝɔi",
  "block.minecraft.snow_block": "ʞɔoꞁᗺ ʍous",
  "block.minecraft.cactus": "snʇɔɐɔ",
  "block.minecraft.clay": "ʎɐꞁɔ",
  "block.minecraft.jukebox": "xoqǝʞnր",
  "block.minecraft.oak_fence": "ǝɔuǝⅎ ʞɐo",
  "block.minecraft.spruce_fence": "ǝɔuǝⅎ ǝɔnɹds",
  "block.minecraft.birch_fence": "ǝɔuǝⅎ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_fence": "ǝɔuǝⅎ ǝꞁᵷunր",
  "block.minecraft.acacia_fence": "ǝɔuǝⅎ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_fence": "ǝɔuǝⅎ ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_fence": "ǝɔuǝⅎ uosɯᴉɹɔ",
  "block.minecraft.warped_fence": "ǝɔuǝⅎ pǝdɹɐm",
  "block.minecraft.pumpkin": "uᴉʞdɯnԁ",
  "block.minecraft.carved_pumpkin": "uᴉʞdɯnԁ pǝʌɹɐɔ",
  "block.minecraft.netherrack": "ʞɔɐɹɹǝɥʇǝn",
  "block.minecraft.soul_sand": "puɐs ꞁnos",
  "block.minecraft.soul_soil": "ꞁᴉos ꞁnos",
  "block.minecraft.basalt": "ʇꞁɐsɐᗺ",
  "block.minecraft.polished_basalt": "ʇꞁɐsɐᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.soul_torch": "ɥɔɹo⟘ ꞁnos",
  "block.minecraft.glowstone": "ǝuoʇsʍoꞁ⅁",
  "block.minecraft.jack_o_lantern": "uɹǝʇuɐꞁ,o ʞɔɐր",
  "block.minecraft.oak_trapdoor": "ɹoopdɐɹ⟘ ʞɐo",
  "block.minecraft.spruce_trapdoor": "ɹoopdɐɹ⟘ ǝɔnɹds",
  "block.minecraft.birch_trapdoor": "ɹoopdɐɹ⟘ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_trapdoor": "ɹoopdɐɹ⟘ ǝꞁᵷunր",
  "block.minecraft.acacia_trapdoor": "ɹoopdɐɹ⟘ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_trapdoor": "ɹoopdɐɹ⟘ ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_trapdoor": "ɹoopdɐɹ⟘ uosɯᴉɹɔ",
  "block.minecraft.warped_trapdoor": "ɹoopdɐɹ⟘ pǝdɹɐm",
  "block.minecraft.infested_stone": "ǝuoʇs pǝʇsǝɟui",
  "block.minecraft.infested_cobblestone": "ǝuoʇsǝꞁqqoɔ pǝʇsǝɟui",
  "block.minecraft.infested_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs pǝʇsǝɟui",
  "block.minecraft.infested_mossy_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs ʎssow pǝʇsǝɟui",
  "block.minecraft.infested_cracked_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs pǝʞɔɐɹɔ pǝʇsǝɟui",
  "block.minecraft.infested_chiseled_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs pǝꞁꞁǝsᴉɥɔ pǝʇsǝɟui",
  "block.minecraft.stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs",
  "block.minecraft.mossy_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs ʎssow",
  "block.minecraft.cracked_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs pǝʞɔɐɹɔ",
  "block.minecraft.chiseled_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs pǝꞁꞁǝsᴉɥɔ",
  "block.minecraft.brown_mushroom_block": "ʞɔoꞁᗺ ɯooɹɥsnw uʍoɹᗺ",
  "block.minecraft.red_mushroom_block": "ʞɔoꞁᗺ ɯooɹɥsnw pǝᴚ",
  "block.minecraft.mushroom_stem": "ɯǝʇs ɯooɹɥsnw",
  "block.minecraft.iron_bars": "sɹɐᗺ uoɹi",
  "block.minecraft.chain": "uᴉɐɥɔ",
  "block.minecraft.glass_pane": "ǝuɐԁ ssɐꞁ⅁",
  "block.minecraft.melon": "uoꞁǝw",
  "block.minecraft.vine": "sǝuᴉʌ",
  "block.minecraft.oak_fence_gate": "ǝʇɐ⅁ ǝɔuǝⅎ ʞɐo",
  "block.minecraft.spruce_fence_gate": "ǝʇɐ⅁ ǝɔuǝⅎ ǝɔnɹds",
  "block.minecraft.birch_fence_gate": "ǝʇɐ⅁ ǝɔuǝⅎ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_fence_gate": "ǝʇɐ⅁ ǝɔuǝⅎ ǝꞁᵷunր",
  "block.minecraft.acacia_fence_gate": "ǝʇɐ⅁ ǝɔuǝⅎ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_fence_gate": "ǝʇɐ⅁ ǝɔuǝⅎ ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_fence_gate": "ǝʇɐ⅁ ǝɔuǝⅎ uosɯᴉɹɔ",
  "block.minecraft.warped_fence_gate": "ǝʇɐ⅁ ǝɔuǝⅎ pǝdɹɐm",
  "block.minecraft.brick_stairs": "sɹᴉɐʇs ʞɔᴉɹᗺ",
  "block.minecraft.stone_brick_stairs": "sɹᴉɐʇs ʞɔᴉɹᗺ ǝuoʇs",
  "block.minecraft.mycelium": "ɯnᴉꞁǝɔʎw",
  "block.minecraft.lily_pad": "pɐԁ ʎꞁᴉꞁ",
  "block.minecraft.nether_bricks": "sʞɔᴉɹᗺ ɹǝɥʇǝn",
  "block.minecraft.cracked_nether_bricks": "sʞɔᴉɹᗺ ɹǝɥʇǝn pǝʞɔɐɹɔ",
  "block.minecraft.chiseled_nether_bricks": "sʞɔᴉɹᗺ ɹǝɥʇǝn pǝꞁꞁǝsᴉɥɔ",
  "block.minecraft.nether_brick_fence": "ǝɔuǝⅎ ʞɔᴉɹᗺ ɹǝɥʇǝn",
  "block.minecraft.nether_brick_stairs": "sɹᴉɐʇs ʞɔᴉɹᗺ ɹǝɥʇǝn",
  "block.minecraft.enchanting_table": "ǝꞁqɐ⟘ ᵷuᴉʇuɐɥɔuǝ",
  "block.minecraft.end_portal_frame": "ǝɯɐɹⅎ ꞁɐʇɹoԁ puǝ",
  "block.minecraft.end_stone": "ǝuoʇs puǝ",
  "block.minecraft.end_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇs puǝ",
  "block.minecraft.dragon_egg": "ᵷᵷǝ uoᵷɐɹᗡ",
  "block.minecraft.redstone_lamp": "dɯɐꞁ ǝuoʇspǝᴚ",
  "block.minecraft.sandstone_stairs": "sɹᴉɐʇs ǝuoʇspuɐs",
  "block.minecraft.emerald_ore": "ǝɹo pꞁɐɹǝɯǝ",
  "block.minecraft.ender_chest": "ʇsǝɥɔ ɹǝpuǝ",
  "block.minecraft.tripwire_hook": "ʞooh ǝɹᴉʍdᴉɹ⟘",
  "block.minecraft.emerald_block": "ʞɔoꞁᗺ pꞁɐɹǝɯǝ",
  "block.minecraft.spruce_stairs": "sɹᴉɐʇs ǝɔnɹds",
  "block.minecraft.birch_stairs": "sɹᴉɐʇs ɥɔɹᴉᗺ",
  "block.minecraft.jungle_stairs": "sɹᴉɐʇs ǝꞁᵷunր",
  "block.minecraft.crimson_stairs": "sɹᴉɐʇs uosɯᴉɹɔ",
  "block.minecraft.warped_stairs": "sɹᴉɐʇs pǝdɹɐm",
  "block.minecraft.command_block": "ʞɔoꞁᗺ puɐɯɯoɔ",
  "block.minecraft.beacon": "uoɔɐǝᗺ",
  "block.minecraft.cobblestone_wall": "ꞁꞁɐm ǝuoʇsǝꞁqqoɔ",
  "block.minecraft.mossy_cobblestone_wall": "ꞁꞁɐm ǝuoʇsǝꞁqqoɔ ʎssow",
  "block.minecraft.brick_wall": "llɐm ʞɔᴉɹᗺ",
  "block.minecraft.prismarine_wall": "llɐm ǝuᴉɹɐɯsᴉɹԁ",
  "block.minecraft.red_sandstone_wall": "llɐm ǝuoʇspuɐs pǝᴚ",
  "block.minecraft.mossy_stone_brick_wall": "llɐm ʞɔᴉɹᗺ ǝuoʇs ʎssow",
  "block.minecraft.granite_wall": "llɐm ǝʇᴉuɐɹ⅁",
  "block.minecraft.stone_brick_wall": "llɐm ʞɔᴉɹᗺ ǝuoʇs",
  "block.minecraft.nether_brick_wall": "llɐm ʞɔᴉɹᗺ ɹǝɥʇǝn",
  "block.minecraft.andesite_wall": "llɐm ǝʇᴉsǝpuɐ",
  "block.minecraft.red_nether_brick_wall": "llɐm ʞɔᴉɹᗺ ɹǝɥʇǝn pǝᴚ",
  "block.minecraft.sandstone_wall": "llɐm ǝuoʇspuɐs",
  "block.minecraft.end_stone_brick_wall": "llɐm ʞɔᴉɹᗺ ǝuoʇs puǝ",
  "block.minecraft.diorite_wall": "llɐm ǝʇᴉɹoᴉᗡ",
  "block.minecraft.blackstone_wall": "ꞁꞁɐm ǝuoʇsʞɔɐꞁᗺ",
  "block.minecraft.polished_blackstone_wall": "llɐm ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.polished_blackstone_brick_wall": "ꞁꞁɐm ʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.stone_button": "uoʇʇnᗺ ǝuoʇs",
  "block.minecraft.oak_button": "uoʇʇnᗺ ʞɐo",
  "block.minecraft.spruce_button": "uoʇʇnᗺ ǝɔnɹds",
  "block.minecraft.birch_button": "uoʇʇnᗺ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_button": "uoʇʇnᗺ ǝꞁᵷunր",
  "block.minecraft.acacia_button": "uoʇʇnᗺ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_button": "uoʇʇnᗺ ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_button": "uoʇʇnᗺ uosɯᴉɹɔ",
  "block.minecraft.warped_button": "uoʇʇnᗺ pǝdɹɐm",
  "block.minecraft.polished_blackstone_button": "uoʇʇnᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.anvil": "ꞁᴉʌuɐ",
  "block.minecraft.chipped_anvil": "ꞁᴉʌuɐ pǝddᴉɥɔ",
  "block.minecraft.damaged_anvil": "ꞁᴉʌuɐ pǝᵷɐɯɐᗡ",
  "block.minecraft.trapped_chest": "ʇsǝɥɔ pǝddɐɹ⟘",
  "block.minecraft.light_weighted_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ pǝʇɥᵷᴉǝm ʇɥᵷᴉꞁ",
  "block.minecraft.heavy_weighted_pressure_plate": "ǝʇɐꞁԁ ǝɹnssǝɹԁ pǝʇɥᵷᴉǝm ʎʌɐǝh",
  "block.minecraft.daylight_detector": "ɹoʇɔǝʇǝᗡ ʇɥᵷᴉꞁʎɐᗡ",
  "block.minecraft.redstone_block": "ʞɔoꞁᗺ ǝuoʇspǝᴚ",
  "block.minecraft.nether_quartz_ore": "ǝɹo zʇɹɐnꝺ ɹǝɥʇǝn",
  "block.minecraft.hopper": "ɹǝddoh",
  "block.minecraft.chiseled_quartz_block": "ʞɔoꞁᗺ zʇɹɐnꝺ pǝꞁꞁǝsᴉɥɔ",
  "block.minecraft.quartz_block": "ʞɔoꞁᗺ zʇɹɐnꝺ",
  "block.minecraft.quartz_bricks": "sʞɔᴉɹᗺ zʇɹɐnꝺ",
  "block.minecraft.quartz_pillar": "ɹɐꞁꞁᴉԁ zʇɹɐnꝺ",
  "block.minecraft.quartz_stairs": "sɹᴉɐʇs zʇɹɐnꝺ",
  "block.minecraft.activator_rail": "ꞁᴉɐᴚ ɹoʇɐʌᴉʇɔɐ",
  "block.minecraft.dropper": "ɹǝddoɹᗡ",
  "block.minecraft.white_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝʇᴉɥm",
  "block.minecraft.orange_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝᵷuɐɹo",
  "block.minecraft.magenta_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝɯᴉꞁ",
  "block.minecraft.pink_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʞuᴉԁ",
  "block.minecraft.gray_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʎǝɹ⅁",
  "block.minecraft.light_gray_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ uɐʎɔ",
  "block.minecraft.purple_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝꞁdɹnԁ",
  "block.minecraft.blue_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝnꞁᗺ",
  "block.minecraft.brown_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ uʍoɹᗺ",
  "block.minecraft.green_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ uǝǝɹ⅁",
  "block.minecraft.red_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝᴚ",
  "block.minecraft.black_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʞɔɐꞁᗺ",
  "block.minecraft.barrier": "ɹǝᴉɹɹɐᗺ",
  "block.minecraft.iron_trapdoor": "ɹoopdɐɹ⟘ uoɹi",
  "block.minecraft.hay_block": "ǝꞁɐᗺ ʎɐh",
  "block.minecraft.white_carpet": "ʇǝdɹɐɔ ǝʇᴉɥm",
  "block.minecraft.orange_carpet": "ʇǝdɹɐɔ ǝᵷuɐɹo",
  "block.minecraft.magenta_carpet": "ʇǝdɹɐɔ ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_carpet": "ʇǝdɹɐɔ ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_carpet": "ʇǝdɹɐɔ ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_carpet": "ʇǝdɹɐɔ ǝɯᴉꞁ",
  "block.minecraft.pink_carpet": "ʇǝdɹɐɔ ʞuᴉԁ",
  "block.minecraft.gray_carpet": "ʇǝdɹɐɔ ʎǝɹ⅁",
  "block.minecraft.light_gray_carpet": "ʇǝdɹɐɔ ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_carpet": "ʇǝdɹɐɔ uɐʎɔ",
  "block.minecraft.purple_carpet": "ʇǝdɹɐɔ ǝꞁdɹnԁ",
  "block.minecraft.blue_carpet": "ʇǝdɹɐɔ ǝnꞁᗺ",
  "block.minecraft.brown_carpet": "ʇǝdɹɐɔ uʍoɹᗺ",
  "block.minecraft.green_carpet": "ʇǝdɹɐɔ uǝǝɹ⅁",
  "block.minecraft.red_carpet": "ʇǝdɹɐɔ pǝᴚ",
  "block.minecraft.black_carpet": "ʇǝdɹɐɔ ʞɔɐꞁᗺ",
  "block.minecraft.terracotta": "ɐʇʇoɔɐɹɹǝ⟘",
  "block.minecraft.coal_block": "ʞɔoꞁᗺ ꞁɐoɔ",
  "block.minecraft.packed_ice": "ǝɔi pǝʞɔɐԁ",
  "block.minecraft.acacia_stairs": "sɹᴉɐʇs ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_stairs": "sɹᴉɐʇs ʞɐo ʞɹɐᗡ",
  "block.minecraft.slime_block": "ʞɔoꞁᗺ ǝɯᴉꞁs",
  "block.minecraft.grass_path": "ɥʇɐԁ ssɐɹ⅁",
  "block.minecraft.sunflower": "ɹǝʍoꞁɟuns",
  "block.minecraft.lilac": "ɔɐꞁᴉꞁ",
  "block.minecraft.rose_bush": "ɥsnᗺ ǝsoᴚ",
  "block.minecraft.peony": "ʎuoǝԁ",
  "block.minecraft.tall_grass": "ssɐɹ⅁ ꞁꞁɐ⟘",
  "block.minecraft.large_fern": "uɹǝⅎ ǝᵷɹɐꞁ",
  "block.minecraft.white_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ǝʇᴉɥm",
  "block.minecraft.orange_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ǝᵷuɐɹo",
  "block.minecraft.magenta_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ǝɯᴉꞁ",
  "block.minecraft.pink_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ʞuᴉԁ",
  "block.minecraft.gray_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ʎǝɹ⅁",
  "block.minecraft.light_gray_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs uɐʎɔ",
  "block.minecraft.purple_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ǝꞁdɹnԁ",
  "block.minecraft.blue_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ǝnꞁᗺ",
  "block.minecraft.brown_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs uʍoɹᗺ",
  "block.minecraft.green_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs uǝǝɹ⅁",
  "block.minecraft.red_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs pǝᴚ",
  "block.minecraft.black_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇs ʞɔɐꞁᗺ",
  "block.minecraft.white_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ǝʇᴉɥm",
  "block.minecraft.orange_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ǝᵷuɐɹo",
  "block.minecraft.magenta_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ǝɯᴉꞁ",
  "block.minecraft.pink_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ʞuᴉԁ",
  "block.minecraft.gray_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ʎǝɹ⅁",
  "block.minecraft.light_gray_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs uɐʎɔ",
  "block.minecraft.purple_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ǝꞁdɹnԁ",
  "block.minecraft.blue_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ǝnꞁᗺ",
  "block.minecraft.brown_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs uʍoɹᗺ",
  "block.minecraft.green_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs uǝǝɹ⅁",
  "block.minecraft.red_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs pǝᴚ",
  "block.minecraft.black_stained_glass_pane": "ǝuɐԁ ssɐꞁ⅁ pǝuᴉɐʇs ʞɔɐꞁᗺ",
  "block.minecraft.prismarine": "ǝuᴉɹɐɯsᴉɹԁ",
  "block.minecraft.prismarine_bricks": "sʞɔᴉɹᗺ ǝuᴉɹɐɯsᴉɹԁ",
  "block.minecraft.dark_prismarine": "ǝuᴉɹɐɯsᴉɹԁ ʞɹɐᗡ",
  "block.minecraft.prismarine_stairs": "sɹᴉɐʇs ǝuᴉɹɐɯsᴉɹԁ",
  "block.minecraft.prismarine_brick_stairs": "sɹᴉɐʇs ʞɔᴉɹᗺ ǝuᴉɹɐɯsᴉɹԁ",
  "block.minecraft.dark_prismarine_stairs": "sɹᴉɐʇs ǝuᴉɹɐɯsᴉɹԁ ʞɹɐᗡ",
  "block.minecraft.sea_lantern": "uɹǝʇuɐꞁ ɐǝs",
  "block.minecraft.red_sandstone": "ǝuoʇspuɐs pǝᴚ",
  "block.minecraft.chiseled_red_sandstone": "ǝuoʇspuɐs pǝᴚ pǝꞁꞁǝsᴉɥɔ",
  "block.minecraft.cut_red_sandstone": "ǝuoʇspuɐs pǝᴚ ʇnɔ",
  "block.minecraft.red_sandstone_stairs": "sɹᴉɐʇs ǝuoʇspuɐs pǝᴚ",
  "block.minecraft.repeating_command_block": "ʞɔoꞁᗺ puɐɯɯoɔ ᵷuᴉʇɐǝdǝᴚ",
  "block.minecraft.chain_command_block": "ʞɔoꞁᗺ puɐɯɯoɔ uᴉɐɥɔ",
  "block.minecraft.magma_block": "ʞɔoꞁᗺ ɐɯᵷɐw",
  "block.minecraft.nether_wart_block": "ʞɔoꞁᗺ ʇɹɐm ɹǝɥʇǝn",
  "block.minecraft.warped_wart_block": "ʞɔoꞁᗺ ʇɹɐm pǝdɹɐm",
  "block.minecraft.red_nether_bricks": "sʞɔᴉɹᗺ ɹǝɥʇǝn pǝᴚ",
  "block.minecraft.bone_block": "ʞɔoꞁᗺ ǝuoᗺ",
  "block.minecraft.structure_void": "pᴉoʌ ǝɹnʇɔnɹʇs",
  "block.minecraft.observer": "ɹǝʌɹǝsqo",
  "block.minecraft.shulker_box": "xoᗺ ɹǝʞꞁnɥs",
  "block.minecraft.white_shulker_box": "xoᗺ ɹǝʞꞁnɥs ǝʇᴉɥm",
  "block.minecraft.orange_shulker_box": "xoᗺ ɹǝʞꞁnɥs ǝᵷuɐɹo",
  "block.minecraft.magenta_shulker_box": "xoᗺ ɹǝʞꞁnɥs ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_shulker_box": "xoᗺ ɹǝʞꞁnɥs ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_shulker_box": "xoᗺ ɹǝʞꞁnɥs ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_shulker_box": "xoᗺ ɹǝʞꞁnɥs ǝɯᴉꞁ",
  "block.minecraft.pink_shulker_box": "xoᗺ ɹǝʞꞁnɥs ʞuᴉԁ",
  "block.minecraft.gray_shulker_box": "xoᗺ ɹǝʞꞁnɥs ʎǝɹ⅁",
  "block.minecraft.light_gray_shulker_box": "xoᗺ ɹǝʞꞁnɥs ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_shulker_box": "xoᗺ ɹǝʞꞁnɥs uɐʎɔ",
  "block.minecraft.purple_shulker_box": "xoᗺ ɹǝʞꞁnɥs ǝꞁdɹnԁ",
  "block.minecraft.blue_shulker_box": "xoᗺ ɹǝʞꞁnɥs ǝnꞁᗺ",
  "block.minecraft.brown_shulker_box": "xoᗺ ɹǝʞꞁnɥs uʍoɹᗺ",
  "block.minecraft.green_shulker_box": "xoᗺ ɹǝʞꞁnɥs uǝǝɹ⅁",
  "block.minecraft.red_shulker_box": "xoᗺ ɹǝʞꞁnɥs pǝᴚ",
  "block.minecraft.black_shulker_box": "xoᗺ ɹǝʞꞁnɥs ʞɔɐꞁᗺ",
  "block.minecraft.white_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝʇᴉɥm",
  "block.minecraft.orange_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝᵷuɐɹo",
  "block.minecraft.magenta_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝɯᴉꞁ",
  "block.minecraft.pink_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʞuᴉԁ",
  "block.minecraft.gray_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʎǝɹ⅁",
  "block.minecraft.light_gray_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ uɐʎɔ",
  "block.minecraft.purple_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝꞁdɹnԁ",
  "block.minecraft.blue_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝnꞁᗺ",
  "block.minecraft.brown_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ uʍoɹᗺ",
  "block.minecraft.green_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ uǝǝɹ⅁",
  "block.minecraft.red_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ pǝᴚ",
  "block.minecraft.black_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʞɔɐꞁᗺ",
  "block.minecraft.white_concrete": "ǝʇǝɹɔuoɔ ǝʇᴉɥm",
  "block.minecraft.orange_concrete": "ǝʇǝɹɔuoɔ ǝᵷuɐɹo",
  "block.minecraft.magenta_concrete": "ǝʇǝɹɔuoɔ ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_concrete": "ǝʇǝɹɔuoɔ ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_concrete": "ǝʇǝɹɔuoɔ ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_concrete": "ǝʇǝɹɔuoɔ ǝɯᴉꞁ",
  "block.minecraft.pink_concrete": "ǝʇǝɹɔuoɔ ʞuᴉԁ",
  "block.minecraft.gray_concrete": "ǝʇǝɹɔuoɔ ʎǝɹ⅁",
  "block.minecraft.light_gray_concrete": "ǝʇǝɹɔuoɔ ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_concrete": "ǝʇǝɹɔuoɔ uɐʎɔ",
  "block.minecraft.purple_concrete": "ǝʇǝɹɔuoɔ ǝꞁdɹnԁ",
  "block.minecraft.blue_concrete": "ǝʇǝɹɔuoɔ ǝnꞁᗺ",
  "block.minecraft.brown_concrete": "ǝʇǝɹɔuoɔ uʍoɹᗺ",
  "block.minecraft.green_concrete": "ǝʇǝɹɔuoɔ uǝǝɹ⅁",
  "block.minecraft.red_concrete": "ǝʇǝɹɔuoɔ pǝᴚ",
  "block.minecraft.black_concrete": "ǝʇǝɹɔuoɔ ʞɔɐꞁᗺ",
  "block.minecraft.white_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ǝʇᴉɥm",
  "block.minecraft.orange_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ǝᵷuɐɹo",
  "block.minecraft.magenta_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ǝɯᴉꞁ",
  "block.minecraft.pink_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ʞuᴉԁ",
  "block.minecraft.gray_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ʎǝɹ⅁",
  "block.minecraft.light_gray_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ uɐʎɔ",
  "block.minecraft.purple_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ǝꞁdɹnԁ",
  "block.minecraft.blue_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ǝnꞁᗺ",
  "block.minecraft.brown_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ uʍoɹᗺ",
  "block.minecraft.green_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ uǝǝɹ⅁",
  "block.minecraft.red_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ pǝᴚ",
  "block.minecraft.black_concrete_powder": "ɹǝpʍoԁ ǝʇǝɹɔuoɔ ʞɔɐꞁᗺ",
  "block.minecraft.turtle_egg": "ᵷᵷǝ ǝꞁʇɹn⟘",
  "block.minecraft.dead_tube_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ ǝqn⟘ pɐǝᗡ",
  "block.minecraft.dead_brain_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ uᴉɐɹᗺ pɐǝᗡ",
  "block.minecraft.dead_bubble_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ ǝꞁqqnᗺ pɐǝᗡ",
  "block.minecraft.dead_fire_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ ǝɹᴉⅎ pɐǝᗡ",
  "block.minecraft.dead_horn_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ uɹoh pɐǝᗡ",
  "block.minecraft.tube_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ ǝqn⟘",
  "block.minecraft.brain_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ uᴉɐɹᗺ",
  "block.minecraft.bubble_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ ǝꞁqqnᗺ",
  "block.minecraft.fire_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ ǝɹᴉⅎ",
  "block.minecraft.horn_coral_block": "ʞɔoꞁᗺ ꞁɐɹoɔ uɹoh",
  "block.minecraft.tube_coral": "ꞁɐɹoɔ ǝqn⟘",
  "block.minecraft.brain_coral": "ꞁɐɹoɔ uᴉɐɹᗺ",
  "block.minecraft.bubble_coral": "ꞁɐɹoɔ ǝꞁqqnᗺ",
  "block.minecraft.fire_coral": "ꞁɐɹoɔ ǝɹᴉⅎ",
  "block.minecraft.horn_coral": "ꞁɐɹoɔ uɹoh",
  "block.minecraft.dead_brain_coral": "ꞁɐɹoɔ uᴉɐɹᗺ pɐǝᗡ",
  "block.minecraft.dead_bubble_coral": "ꞁɐɹoɔ ǝꞁqqnᗺ pɐǝᗡ",
  "block.minecraft.dead_fire_coral": "ꞁɐɹoɔ ǝɹᴉⅎ pɐǝᗡ",
  "block.minecraft.dead_horn_coral": "ꞁɐɹoɔ uɹoh pɐǝᗡ",
  "block.minecraft.dead_tube_coral": "ꞁɐɹoɔ ǝqn⟘ pɐǝᗡ",
  "block.minecraft.tube_coral_fan": "uɐⅎ ꞁɐɹoɔ ǝqn⟘",
  "block.minecraft.brain_coral_fan": "uɐⅎ ꞁɐɹoɔ uᴉɐɹᗺ",
  "block.minecraft.bubble_coral_fan": "uɐⅎ ꞁɐɹoɔ ǝꞁqqnᗺ",
  "block.minecraft.fire_coral_fan": "uɐⅎ ꞁɐɹoɔ ǝɹᴉⅎ",
  "block.minecraft.horn_coral_fan": "uɐⅎ ꞁɐɹoɔ uɹoh",
  "block.minecraft.dead_tube_coral_fan": "uɐⅎ ꞁɐɹoɔ ǝqn⟘ pɐǝᗡ",
  "block.minecraft.dead_brain_coral_fan": "uɐⅎ ꞁɐɹoɔ uᴉɐɹᗺ pɐǝᗡ",
  "block.minecraft.dead_bubble_coral_fan": "uɐⅎ ꞁɐɹoɔ ǝꞁqqnᗺ pɐǝᗡ",
  "block.minecraft.dead_fire_coral_fan": "uɐⅎ ꞁɐɹoɔ ǝɹᴉⅎ pɐǝᗡ",
  "block.minecraft.dead_horn_coral_fan": "uɐⅎ ꞁɐɹoɔ uɹoh pɐǝᗡ",
  "block.minecraft.blue_ice": "ǝɔi ǝnꞁᗺ",
  "block.minecraft.conduit": "ʇᴉnpuoɔ",
  "block.minecraft.polished_granite_stairs": "sɹᴉɐʇs ǝʇᴉuɐɹ⅁ pǝɥsᴉꞁoԁ",
  "block.minecraft.smooth_red_sandstone_stairs": "sɹᴉɐʇs ǝuoʇspuɐs pǝᴚ ɥʇooɯs",
  "block.minecraft.mossy_stone_brick_stairs": "sɹᴉɐʇs ʞɔᴉɹᗺ ǝuoʇs ʎssow",
  "block.minecraft.polished_diorite_stairs": "sɹᴉɐʇs ǝʇᴉɹoᴉᗡ pǝɥsᴉꞁoԁ",
  "block.minecraft.mossy_cobblestone_stairs": "sɹᴉɐʇs ǝuoʇsǝꞁqqoɔ ʎssow",
  "block.minecraft.end_stone_brick_stairs": "sɹᴉɐʇs ʞɔᴉɹᗺ ǝuoʇs puǝ",
  "block.minecraft.stone_stairs": "sɹᴉɐʇs ǝuoʇs",
  "block.minecraft.smooth_sandstone_stairs": "sɹᴉɐʇs ǝuoʇspuɐs ɥʇooɯs",
  "block.minecraft.smooth_quartz_stairs": "sɹᴉɐʇs zʇɹɐnꝺ ɥʇooɯs",
  "block.minecraft.granite_stairs": "sɹᴉɐʇs ǝʇᴉuɐɹ⅁",
  "block.minecraft.andesite_stairs": "sɹᴉɐʇs ǝʇᴉsǝpuɐ",
  "block.minecraft.red_nether_brick_stairs": "sɹᴉɐʇs ʞɔᴉɹᗺ ɹǝɥʇǝn pǝᴚ",
  "block.minecraft.polished_andesite_stairs": "sɹᴉɐʇs ǝʇᴉsǝpuɐ pǝɥsᴉꞁoԁ",
  "block.minecraft.diorite_stairs": "sɹᴉɐʇs ǝʇᴉɹoᴉᗡ",
  "block.minecraft.polished_granite_slab": "qɐꞁs ǝʇᴉuɐɹ⅁ pǝɥsᴉꞁoԁ",
  "block.minecraft.smooth_red_sandstone_slab": "qɐꞁs ǝuoʇspuɐs pǝᴚ ɥʇooɯs",
  "block.minecraft.mossy_stone_brick_slab": "qɐꞁs ʞɔᴉɹᗺ ǝuoʇs ʎssow",
  "block.minecraft.polished_diorite_slab": "qɐꞁs ǝʇᴉɹoᴉᗡ pǝɥsᴉꞁoԁ",
  "block.minecraft.mossy_cobblestone_slab": "qɐꞁs ǝuoʇsǝꞁqqoɔ ʎssow",
  "block.minecraft.end_stone_brick_slab": "qɐꞁs ʞɔᴉɹᗺ ǝuoʇs puǝ",
  "block.minecraft.smooth_sandstone_slab": "qɐꞁs ǝuoʇspuɐs ɥʇooɯs",
  "block.minecraft.smooth_quartz_slab": "qɐꞁs zʇɹɐnꝺ ɥʇooɯs",
  "block.minecraft.granite_slab": "qɐꞁs ǝʇᴉuɐɹ⅁",
  "block.minecraft.andesite_slab": "qɐꞁs ǝʇᴉsǝpuɐ",
  "block.minecraft.red_nether_brick_slab": "qɐꞁs ʞɔᴉɹᗺ ɹǝɥʇǝn pǝᴚ",
  "block.minecraft.polished_andesite_slab": "qɐꞁs ǝʇᴉsǝpuɐ pǝɥsᴉꞁoԁ",
  "block.minecraft.diorite_slab": "qɐꞁs ǝʇᴉɹoᴉᗡ",
  "block.minecraft.scaffolding": "ᵷuᴉpꞁoɟɟɐɔs",
  "block.minecraft.iron_door": "ɹooᗡ uoɹi",
  "block.minecraft.oak_door": "ɹooᗡ ʞɐo",
  "block.minecraft.spruce_door": "ɹooᗡ ǝɔnɹds",
  "block.minecraft.birch_door": "ɹooᗡ ɥɔɹᴉᗺ",
  "block.minecraft.jungle_door": "ɹooᗡ ǝꞁᵷunր",
  "block.minecraft.acacia_door": "ɹooᗡ ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_door": "ɹooᗡ ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_door": "ɹooᗡ uosɯᴉɹɔ",
  "block.minecraft.warped_door": "ɹooᗡ pǝdɹɐm",
  "block.minecraft.repeater": "ɹǝʇɐǝdǝᴚ ǝuoʇspǝᴚ",
  "block.minecraft.comparator": "ɹoʇɐɹɐdɯoɔ ǝuoʇspǝᴚ",
  "block.minecraft.structure_block": "ʞɔoꞁᗺ ǝɹnʇɔnɹʇs",
  "block.minecraft.jigsaw": "ʞɔoꞁᗺ ʍɐsᵷᴉſ",
  "item.minecraft.turtle_helmet": "ꞁꞁǝɥs ǝꞁʇɹn⟘□□:pɐǝh uo uǝɥm□ɹnoɯɹɐ 2+",
  "item.minecraft.scute": "ǝʇnɔs",
  "item.minecraft.iron_shovel": "ꞁǝʌoɥs uoɹi□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 3.5+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.iron_pickaxe": "ǝxɐʞɔᴉԁ uoɹi□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 3+□pǝǝds ʞɔɐʇʇɐ 2.8-",
  "item.minecraft.iron_axe": "ǝxɐ uoɹi□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 8+□pǝǝds ʞɔɐʇʇɐ 3.1-",
  "item.minecraft.flint_and_steel": "ꞁǝǝʇs puɐ ʇuᴉꞁⅎ",
  "item.minecraft.apple": "ǝꞁddɐ",
  "item.minecraft.bow": "ʍoᗺ",
  "item.minecraft.arrow": "ʍoɹɹɐ",
  "item.minecraft.coal": "ꞁɐoɔ",
  "item.minecraft.charcoal": "ꞁɐoɔɹɐɥɔ",
  "item.minecraft.diamond": "puoɯɐᴉᗡ",
  "item.minecraft.iron_ingot": "ʇoᵷui uoɹi",
  "item.minecraft.gold_ingot": "ʇoᵷui pꞁo⅁",
  "item.minecraft.netherite_ingot": "ʇoᵷui ǝʇᴉɹǝɥʇǝn",
  "item.minecraft.netherite_scrap": "dɐɹɔs ǝʇᴉɹǝɥʇǝn",
  "item.minecraft.iron_sword": "pɹoʍs uoɹi□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 5+□pǝǝds ʞɔɐʇʇɐ 2.4-",
  "item.minecraft.wooden_sword": "pɹoʍs uǝpoom□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 3+□pǝǝds ʞɔɐʇʇɐ 2.4-",
  "item.minecraft.wooden_shovel": "ꞁǝʌoɥs uǝpoom□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 1.5+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.wooden_pickaxe": "ǝxɐʞɔᴉԁ uǝpoom□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 1+□pǝǝds ʞɔɐʇʇɐ 2.8-",
  "item.minecraft.wooden_axe": "ǝxɐ uǝpoom□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 6+□pǝǝds ʞɔɐʇʇɐ 3.2-",
  "item.minecraft.stone_sword": "pɹoʍs ǝuoʇs□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 4+□pǝǝds ʞɔɐʇʇɐ 2.4-",
  "item.minecraft.stone_shovel": "ꞁǝʌoɥs ǝuoʇs□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 2.5+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.stone_pickaxe": "ǝxɐʞɔᴉԁ ǝuoʇs□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 2+□pǝǝds ʞɔɐʇʇɐ 2.8-",
  "item.minecraft.stone_axe": "ǝxɐ ǝuoʇs□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 8+□pǝǝds ʞɔɐʇʇɐ 3.2-",
  "item.minecraft.diamond_sword": "pɹoʍs puoɯɐᴉᗡ□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 6+□pǝǝds ʞɔɐʇʇɐ 2.4-",
  "item.minecraft.diamond_shovel": "ꞁǝʌoɥs puoɯɐᴉᗡ□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 4.5+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.diamond_pickaxe": "ǝxɐʞɔᴉԁ puoɯɐᴉᗡ□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 4+□pǝǝds ʞɔɐʇʇɐ 2.8-",
  "item.minecraft.diamond_axe": "ǝxɐ puoɯɐᴉᗡ□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 8+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.stick": "ʞɔᴉʇs",
  "item.minecraft.bowl": "ꞁʍoᗺ",
  "item.minecraft.mushroom_stew": "dnos ɯooɹɥsnw",
  "item.minecraft.golden_sword": "pɹoʍs uǝpꞁo⅁□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 3+□pǝǝds ʞɔɐʇʇɐ 2.4-",
  "item.minecraft.golden_shovel": "ꞁǝʌoɥs uǝpꞁo⅁□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 1.5+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.golden_pickaxe": "ǝxɐʞɔᴉԁ uǝpꞁo⅁□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 1+□pǝǝds ʞɔɐʇʇɐ 2.8-",
  "item.minecraft.golden_axe": "ǝxɐ uǝpꞁo⅁□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 6+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.netherite_sword": "pɹoʍs ǝʇᴉɹǝɥʇǝn□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 7+□pǝǝds ʞɔɐʇʇɐ 2.4-",
  "item.minecraft.netherite_shovel": "ꞁǝʌoɥs ǝʇᴉɹǝɥʇǝn□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 5.5+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.netherite_pickaxe": "ǝxɐʞɔᴉԁ ǝʇᴉɹǝɥʇǝn□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 5+□pǝǝds ʞɔɐʇʇɐ 2.8-",
  "item.minecraft.netherite_axe": "ǝxɐ ǝʇᴉɹǝɥʇǝn□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 9+□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.string": "ᵷuᴉɹʇs",
  "item.minecraft.feather": "ɹǝɥʇɐǝⅎ",
  "item.minecraft.gunpowder": "ɹǝpʍodun⅁",
  "item.minecraft.wooden_hoe": "ǝoh uǝpoom□□:puɐh uᴉɐw uᴉ uǝɥm□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.stone_hoe": "ǝoh ǝuoʇs□□:puɐh uᴉɐw uᴉ uǝɥm□pǝǝds ʞɔɐʇʇɐ 2-",
  "item.minecraft.iron_hoe": "ǝoh uoɹi□□:puɐh uᴉɐw uᴉ uǝɥm□pǝǝds ʞɔɐʇʇɐ 1-",
  "item.minecraft.diamond_hoe": "ǝoh puoɯɐᴉᗡ□□:puɐh uᴉɐw uᴉ uǝɥm",
  "item.minecraft.golden_hoe": "ǝoh uǝpꞁo⅁□□:puɐh uᴉɐw uᴉ uǝɥm□pǝǝds ʞɔɐʇʇɐ 3-",
  "item.minecraft.netherite_hoe": "ǝoh ǝʇᴉɹǝɥʇǝn□□:puɐh uᴉɐw uᴉ uǝɥm",
  "item.minecraft.wheat_seeds": "spǝǝs ʇɐǝɥm",
  "item.minecraft.wheat": "ʇɐǝɥm",
  "item.minecraft.bread": "pɐǝɹᗺ",
  "item.minecraft.leather_helmet": "ʇɐh ɹǝɥʇɐǝꞁ□□:pɐǝh uo uǝɥm□ɹnoɯɹɐ 1+",
  "item.minecraft.leather_chestplate": "ɔᴉun⟘ ɹǝɥʇɐǝꞁ□□:ʎpoᗺ uo uǝɥm□ɹnoɯɹɐ 3+",
  "item.minecraft.leather_leggings": "sɹǝsnoɹ⟘ ɹǝɥʇɐǝꞁ□□:sᵷǝꞁ uo uǝɥm□ɹnoɯɹɐ 2+",
  "item.minecraft.leather_boots": "sʇooᗺ ɹǝɥʇɐǝꞁ□□:ʇǝǝⅎ uo uǝɥm□ɹnoɯɹɐ 1+",
  "item.minecraft.chainmail_helmet": "ʇǝɯꞁǝh ꞁᴉɐɯuᴉɐɥɔ□□:pɐǝh uo uǝɥm□ɹnoɯɹɐ 2+",
  "item.minecraft.chainmail_chestplate": "ǝʇɐꞁdʇsǝɥɔ ꞁᴉɐɯuᴉɐɥɔ□□:ʎpoᗺ uo uǝɥm□ɹnoɯɹɐ 5+",
  "item.minecraft.chainmail_leggings": "sᵷuᴉᵷᵷǝꞁ ꞁᴉɐɯuᴉɐɥɔ□□:sᵷǝꞁ uo uǝɥm□ɹnoɯɹɐ 4+",
  "item.minecraft.chainmail_boots": "sʇooᗺ ꞁᴉɐɯuᴉɐɥɔ□□:ʇǝǝⅎ uo uǝɥm□ɹnoɯɹɐ 1+",
  "item.minecraft.iron_helmet": "ʇǝɯꞁǝh uoɹi□□:pɐǝh uo uǝɥm□ɹnoɯɹɐ 2+",
  "item.minecraft.iron_chestplate": "ǝʇɐꞁdʇsǝɥɔ uoɹi□□:ʎpoᗺ uo uǝɥm□ɹnoɯɹɐ 6+",
  "item.minecraft.iron_leggings": "sᵷuᴉᵷᵷǝꞁ uoɹi□□:sᵷǝꞁ uo uǝɥm□ɹnoɯɹɐ 5+",
  "item.minecraft.iron_boots": "sʇooᗺ uoɹi□□:ʇǝǝⅎ uo uǝɥm□ɹnoɯɹɐ 2+",
  "item.minecraft.diamond_helmet": "ʇǝɯꞁǝh puoɯɐᴉᗡ□□:pɐǝh uo uǝɥm□ɹnoɯɹɐ 3+□ssǝuɥᵷno⟘ ɹnoɯɹɐ 2+",
  "item.minecraft.diamond_chestplate": "ǝʇɐꞁdʇsǝɥɔ puoɯɐᴉᗡ□□:ʎpoᗺ uo uǝɥm□ɹnoɯɹɐ 8+□ssǝuɥᵷno⟘ ɹnoɯɹɐ 2+",
  "item.minecraft.diamond_leggings": "sᵷuᴉᵷᵷǝꞁ puoɯɐᴉᗡ□□:sᵷǝꞁ uo uǝɥm□ɹnoɯɹɐ 6+□ssǝuɥᵷno⟘ ɹnoɯɹɐ 2+",
  "item.minecraft.diamond_boots": "sʇooᗺ puoɯɐᴉᗡ□□:ʇǝǝⅎ uo uǝɥm□ɹnoɯɹɐ 3+□ssǝuɥᵷno⟘ ɹnoɯɹɐ 2+",
  "item.minecraft.golden_helmet": "ʇǝɯꞁǝh uǝpꞁo⅁□□:pɐǝh uo uǝɥm□ɹnoɯɹɐ 2+",
  "item.minecraft.golden_chestplate": "ǝʇɐꞁdʇsǝɥɔ uǝpꞁo⅁□□:ʎpoᗺ uo uǝɥm□ɹnoɯɹɐ 5+",
  "item.minecraft.golden_leggings": "sᵷuᴉᵷᵷǝꞁ uǝpꞁo⅁□□:sᵷǝꞁ uo uǝɥm□ɹnoɯɹɐ 3+",
  "item.minecraft.golden_boots": "sʇooᗺ uǝpꞁo⅁□□:ʇǝǝⅎ uo uǝɥm□ɹnoɯɹɐ 1+",
  "item.minecraft.netherite_helmet": "ʇǝɯꞁǝh ǝʇᴉɹǝɥʇǝn□□:pɐǝh uo uǝɥm□ɹnoɯɹɐ 3+□ssǝuɥᵷno⟘ ɹnoɯɹɐ 3+□ǝɔuɐʇsᴉsǝᴚ ʞɔɐqʞɔouʞ 1+",
  "item.minecraft.netherite_chestplate": "ǝʇɐꞁdʇsǝɥɔ ǝʇᴉɹǝɥʇǝn□□:ʎpoᗺ uo uǝɥm□ɹnoɯɹɐ 8+□ssǝuɥᵷno⟘ ɹnoɯɹɐ 3+□ǝɔuɐʇsᴉsǝᴚ ʞɔɐqʞɔouʞ 1+",
  "item.minecraft.netherite_leggings": "sᵷuᴉᵷᵷǝꞁ ǝʇᴉɹǝɥʇǝn□□:sᵷǝꞁ uo uǝɥm□ɹnoɯɹɐ 6+□ssǝuɥᵷno⟘ ɹnoɯɹɐ 3+□ǝɔuɐʇsᴉsǝᴚ ʞɔɐqʞɔouʞ 1+",
  "item.minecraft.netherite_boots": "sʇooᗺ ǝʇᴉɹǝɥʇǝn□□:ʇǝǝⅎ uo uǝɥm□ɹnoɯɹɐ 3+□ssǝuɥᵷno⟘ ɹnoɯɹɐ 3+□ǝɔuɐʇsᴉsǝᴚ ʞɔɐqʞɔouʞ 1+",
  "item.minecraft.flint": "ʇuᴉꞁⅎ",
  "item.minecraft.porkchop": "doɥɔʞɹoԁ ʍɐᴚ",
  "item.minecraft.cooked_porkchop": "doɥɔʞɹoԁ pǝʞooɔ",
  "item.minecraft.painting": "ᵷuᴉʇuᴉɐԁ",
  "item.minecraft.golden_apple": "ǝꞁddɐ uǝpꞁo⅁",
  "item.minecraft.enchanted_golden_apple": "ǝꞁddɐ uǝpꞁo⅁ pǝʇuɐɥɔuǝ",
  "block.minecraft.oak_sign": "uᵷᴉs ʞɐo",
  "block.minecraft.spruce_sign": "uᵷᴉs ǝɔnɹds",
  "block.minecraft.birch_sign": "uᵷᴉs ɥɔɹᴉᗺ",
  "block.minecraft.jungle_sign": "uᵷᴉs ǝlᵷunſ",
  "block.minecraft.acacia_sign": "uᵷᴉs ɐᴉɔɐɔɐ",
  "block.minecraft.dark_oak_sign": "uᵷᴉs ʞɐo ʞɹɐᗡ",
  "block.minecraft.crimson_sign": "uᵷᴉs uosɯᴉɹɔ",
  "block.minecraft.warped_sign": "uᵷᴉs pǝdɹɐm",
  "item.minecraft.bucket": "ʇǝʞɔnᗺ",
  "item.minecraft.water_bucket": "ʇǝʞɔnᗺ ɹǝʇɐm",
  "item.minecraft.lava_bucket": "ʇǝʞɔnᗺ ɐʌɐꞁ",
  "item.minecraft.minecart": "ʇɹɐɔǝuᴉw",
  "item.minecraft.saddle": "ǝꞁppɐs",
  "item.minecraft.redstone": "ʇsnᗡ ǝuoʇspǝᴚ",
  "item.minecraft.snowball": "ꞁꞁɐqʍous",
  "item.minecraft.oak_boat": "ʇɐoᗺ ʞɐo",
  "item.minecraft.leather": "ɹǝɥʇɐǝꞁ",
  "item.minecraft.milk_bucket": "ʇǝʞɔnᗺ ʞꞁᴉw",
  "item.minecraft.pufferfish_bucket": "ɥsᴉɟɹǝɟɟnԁ ɟo ʇǝʞɔnᗺ",
  "item.minecraft.salmon_bucket": "uoɯꞁɐs ɟo ʇǝʞɔnᗺ",
  "item.minecraft.cod_bucket": "poɔ ɟo ʇǝʞɔnᗺ",
  "item.minecraft.tropical_fish_bucket": "ɥsᴉⅎ ꞁɐɔᴉdoɹ⟘ ɟo ʇǝʞɔnᗺ",
  "item.minecraft.brick": "ʞɔᴉɹᗺ",
  "item.minecraft.clay_ball": "ꞁꞁɐᗺ ʎɐꞁɔ",
  "block.minecraft.dried_kelp_block": "ʞɔoꞁᗺ dꞁǝʞ pǝᴉɹᗡ",
  "item.minecraft.paper": "ɹǝdɐԁ",
  "item.minecraft.book": "ʞooᗺ",
  "item.minecraft.slime_ball": "ꞁꞁɐqǝɯᴉꞁs",
  "item.minecraft.chest_minecart": "ʇsǝɥɔ ɥʇᴉʍ ʇɹɐɔǝuᴉw",
  "item.minecraft.furnace_minecart": "ǝɔɐuɹnⅎ ɥʇᴉʍ ʇɹɐɔǝuᴉw",
  "item.minecraft.egg": "ᵷᵷǝ",
  "item.minecraft.compass": "ssɐdɯoɔ",
  "item.minecraft.fishing_rod": "poᴚ ᵷuᴉɥsᴉⅎ",
  "item.minecraft.clock": "ʞɔoꞁɔ",
  "item.minecraft.glowstone_dust": "ʇsnᗡ ǝuoʇsʍoꞁ⅁",
  "item.minecraft.cod": "poɔ ʍɐᴚ",
  "item.minecraft.salmon": "uoɯꞁɐs ʍɐᴚ",
  "item.minecraft.tropical_fish": "ɥsᴉⅎ ꞁɐɔᴉdoɹ⟘",
  "item.minecraft.pufferfish": "ɥsᴉɟɹǝɟɟnԁ",
  "item.minecraft.cooked_cod": "poɔ pǝʞooɔ",
  "item.minecraft.cooked_salmon": "uoɯꞁɐs pǝʞooɔ",
  "item.minecraft.ink_sac": "ɔɐs ʞui",
  "item.minecraft.red_dye": "ǝʎᗡ pǝᴚ",
  "item.minecraft.green_dye": "ǝʎᗡ uǝǝɹ⅁",
  "item.minecraft.cocoa_beans": "suɐǝᗺ ɐoɔoɔ",
  "item.minecraft.lapis_lazuli": "ᴉꞁnzɐꞁ sᴉdɐꞁ",
  "item.minecraft.purple_dye": "ǝʎᗡ ǝꞁdɹnԁ",
  "item.minecraft.cyan_dye": "ǝʎᗡ uɐʎɔ",
  "item.minecraft.light_gray_dye": "ǝʎᗡ ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "item.minecraft.gray_dye": "ǝʎᗡ ʎǝɹ⅁",
  "item.minecraft.pink_dye": "ǝʎᗡ ʞuᴉԁ",
  "item.minecraft.lime_dye": "ǝʎᗡ ǝɯᴉꞁ",
  "item.minecraft.yellow_dye": "ǝʎᗡ ʍoꞁꞁǝ⅄",
  "item.minecraft.light_blue_dye": "ǝʎᗡ ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "item.minecraft.magenta_dye": "ǝʎᗡ ɐʇuǝᵷɐw",
  "item.minecraft.orange_dye": "ǝʎᗡ ǝᵷuɐɹo",
  "item.minecraft.bone_meal": "ꞁɐǝw ǝuoᗺ",
  "item.minecraft.blue_dye": "ǝʎᗡ ǝnꞁᗺ",
  "item.minecraft.brown_dye": "ǝʎᗡ uʍoɹᗺ",
  "item.minecraft.black_dye": "ǝʎᗡ ʞɔɐꞁᗺ",
  "item.minecraft.white_dye": "ǝʎᗡ ǝʇᴉɥm",
  "item.minecraft.bone": "ǝuoᗺ",
  "item.minecraft.sugar": "ɹɐᵷns",
  "block.minecraft.cake": "ǝʞɐɔ",
  "block.minecraft.white_bed": "pǝᗺ ǝʇᴉɥm",
  "block.minecraft.orange_bed": "pǝᗺ ǝᵷuɐɹo",
  "block.minecraft.magenta_bed": "pǝᗺ ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_bed": "pǝᗺ ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_bed": "pǝᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_bed": "pǝᗺ ǝɯᴉꞁ",
  "block.minecraft.pink_bed": "pǝᗺ ʞuᴉԁ",
  "block.minecraft.gray_bed": "pǝᗺ ʎǝɹ⅁",
  "block.minecraft.light_gray_bed": "pǝᗺ ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_bed": "pǝᗺ uɐʎɔ",
  "block.minecraft.purple_bed": "pǝᗺ ǝꞁdɹnԁ",
  "block.minecraft.blue_bed": "pǝᗺ ǝnꞁᗺ",
  "block.minecraft.brown_bed": "pǝᗺ uʍoɹᗺ",
  "block.minecraft.green_bed": "pǝᗺ uǝǝɹ⅁",
  "block.minecraft.red_bed": "pǝᗺ pǝᴚ",
  "block.minecraft.black_bed": "pǝᗺ ʞɔɐꞁᗺ",
  "item.minecraft.cookie": "ʇᴉnɔsᴉᗺ",
  "item.minecraft.filled_map": "dɐw□#0",
  "item.minecraft.shears": "sɹɐǝɥs",
  "item.minecraft.melon_slice": "ǝɔᴉꞁs uoꞁǝw",
  "item.minecraft.dried_kelp": "dꞁǝʞ pǝᴉɹᗡ",
  "item.minecraft.pumpkin_seeds": "spǝǝs uᴉʞdɯnԁ",
  "item.minecraft.melon_seeds": "spǝǝs uoꞁǝw",
  "item.minecraft.beef": "ɟǝǝᗺ ʍɐᴚ",
  "item.minecraft.cooked_beef": "ʞɐǝʇs",
  "item.minecraft.chicken": "uǝʞɔᴉɥɔ ʍɐᴚ",
  "item.minecraft.cooked_chicken": "uǝʞɔᴉɥɔ ʇsɐoᴚ",
  "item.minecraft.rotten_flesh": "ɥsǝꞁⅎ uǝʇʇoᴚ",
  "item.minecraft.ender_pearl": "ꞁɹɐǝԁ ɹǝpuǝ",
  "item.minecraft.blaze_rod": "poᴚ ǝzɐꞁᗺ",
  "item.minecraft.ghast_tear": "ɹɐǝ⟘ ʇsɐɥ⅁",
  "item.minecraft.gold_nugget": "ʇǝᵷᵷnn uǝpꞁo⅁",
  "item.minecraft.nether_wart": "ʇɹɐm ɹǝɥʇǝn",
  "item.minecraft.potion": "uoᴉʇoԁ ǝꞁqɐʇɟɐɹɔu∩□sʇɔǝɟɟǝ on",
  "item.minecraft.glass_bottle": "ǝꞁʇʇoᗺ ssɐꞁ⅁",
  "item.minecraft.spider_eye": "ǝʎǝ ɹǝpᴉds",
  "item.minecraft.fermented_spider_eye": "ǝʎǝ ɹǝpᴉds pǝʇuǝɯɹǝⅎ",
  "item.minecraft.blaze_powder": "ɹǝpʍoԁ ǝzɐꞁᗺ",
  "item.minecraft.magma_cream": "ɯɐǝɹɔ ɐɯᵷɐw",
  "block.minecraft.brewing_stand": "puɐʇs ᵷuᴉʍǝɹᗺ",
  "block.minecraft.cauldron": "uoɹpꞁnɐɔ",
  "item.minecraft.ender_eye": "ɹǝpuǝ ɟo ǝʎǝ",
  "item.minecraft.glistering_melon_slice": "ǝɔᴉꞁs uoꞁǝw ᵷuᴉɹǝʇsᴉꞁ⅁",
  "item.minecraft.bat_spawn_egg": "ᵷᵷǝ uʍɐds ʇɐᗺ",
  "item.minecraft.bee_spawn_egg": "ᵷᵷǝ uʍɐds ǝǝᗺ",
  "item.minecraft.blaze_spawn_egg": "ᵷᵷǝ uʍɐds ǝzɐꞁᗺ",
  "item.minecraft.cat_spawn_egg": "ᵷᵷǝ uʍɐds ʇɐɔ",
  "item.minecraft.cave_spider_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝpᴉds ǝʌɐɔ",
  "item.minecraft.chicken_spawn_egg": "ᵷᵷǝ uʍɐds uǝʞɔᴉɥɔ",
  "item.minecraft.cod_spawn_egg": "ᵷᵷǝ uʍɐds poɔ",
  "item.minecraft.cow_spawn_egg": "ᵷᵷǝ uʍɐds ʍoɔ",
  "item.minecraft.creeper_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝdǝǝɹɔ",
  "item.minecraft.dolphin_spawn_egg": "ᵷᵷǝ uʍɐds uᴉɥdꞁoᗡ",
  "item.minecraft.donkey_spawn_egg": "ᵷᵷǝ uʍɐds ʎǝʞuoᗡ",
  "item.minecraft.drowned_spawn_egg": "ᵷᵷǝ uʍɐds pǝuʍoɹᗡ",
  "item.minecraft.elder_guardian_spawn_egg": "ᵷᵷǝ uʍɐds uɐᴉpɹɐn⅁ ɹǝpꞁǝ",
  "item.minecraft.enderman_spawn_egg": "ᵷᵷǝ uʍɐds uɐɯɹǝpuǝ",
  "item.minecraft.endermite_spawn_egg": "ᵷᵷǝ uʍɐds ǝʇᴉɯɹǝpuǝ",
  "item.minecraft.evoker_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝʞoʌǝ",
  "item.minecraft.fox_spawn_egg": "ᵷᵷǝ uʍɐds xoⅎ",
  "item.minecraft.ghast_spawn_egg": "ᵷᵷǝ uʍɐds ʇsɐɥ⅁",
  "item.minecraft.guardian_spawn_egg": "ᵷᵷǝ uʍɐds uɐᴉpɹɐn⅁",
  "item.minecraft.hoglin_spawn_egg": "ᵷᵷǝ uʍɐds uᴉꞁᵷoh",
  "item.minecraft.horse_spawn_egg": "ᵷᵷǝ uʍɐds ǝsɹoh",
  "item.minecraft.husk_spawn_egg": "ᵷᵷǝ uʍɐds ʞsnh",
  "item.minecraft.llama_spawn_egg": "ᵷᵷǝ uʍɐds ɐɯɐꞁꞁ",
  "item.minecraft.magma_cube_spawn_egg": "ᵷᵷǝ uʍɐds ǝqnɔ ɐɯᵷɐw",
  "item.minecraft.mooshroom_spawn_egg": "ᵷᵷǝ uʍɐds ɯooɹɥsoow",
  "item.minecraft.mule_spawn_egg": "ᵷᵷǝ uʍɐds ǝꞁnw",
  "item.minecraft.ocelot_spawn_egg": "ᵷᵷǝ uʍɐds ʇoꞁǝɔo",
  "item.minecraft.panda_spawn_egg": "ᵷᵷǝ uʍɐds ɐpuɐԁ",
  "item.minecraft.parrot_spawn_egg": "ᵷᵷǝ uʍɐds ʇoɹɹɐԁ",
  "item.minecraft.phantom_spawn_egg": "ᵷᵷǝ uʍɐds ɯoʇuɐɥԁ",
  "item.minecraft.pig_spawn_egg": "ᵷᵷǝ uʍɐds ᵷᴉԁ",
  "item.minecraft.piglin_spawn_egg": "ᵷᵷǝ uʍɐds uᴉꞁᵷᴉԁ",
  "item.minecraft.pillager_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝᵷɐꞁꞁᴉԁ",
  "item.minecraft.polar_bear_spawn_egg": "ᵷᵷǝ uʍɐds ɹɐǝᗺ ɹɐꞁoԁ",
  "item.minecraft.pufferfish_spawn_egg": "ᵷᵷǝ uʍɐds ɥsᴉɟɹǝɟɟnԁ",
  "item.minecraft.rabbit_spawn_egg": "ᵷᵷǝ uʍɐds ʇᴉqqɐᴚ",
  "item.minecraft.ravager_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝᵷɐʌɐᴚ",
  "item.minecraft.salmon_spawn_egg": "ᵷᵷǝ uʍɐds uoɯꞁɐs",
  "item.minecraft.sheep_spawn_egg": "ᵷᵷǝ uʍɐds dǝǝɥs",
  "item.minecraft.shulker_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝʞꞁnɥs",
  "item.minecraft.silverfish_spawn_egg": "ᵷᵷǝ uʍɐds ɥsᴉɟɹǝʌꞁᴉs",
  "item.minecraft.skeleton_spawn_egg": "ᵷᵷǝ uʍɐds uoʇǝꞁǝʞs",
  "item.minecraft.skeleton_horse_spawn_egg": "ᵷᵷǝ uʍɐds ǝsɹoh uoʇǝꞁǝʞs",
  "item.minecraft.slime_spawn_egg": "ᵷᵷǝ uʍɐds ǝɯᴉꞁs",
  "item.minecraft.spider_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝpᴉds",
  "item.minecraft.squid_spawn_egg": "ᵷᵷǝ uʍɐds pᴉnbs",
  "item.minecraft.stray_spawn_egg": "ᵷᵷǝ uʍɐds ʎɐɹʇs",
  "item.minecraft.strider_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝpᴉɹʇs",
  "item.minecraft.trader_llama_spawn_egg": "ᵷᵷǝ uʍɐds ɐɯɐl˥ ɹǝpɐɹ⟘",
  "item.minecraft.tropical_fish_spawn_egg": "ᵷᵷǝ uʍɐds ɥsᴉⅎ ꞁɐɔᴉdoɹ⟘",
  "item.minecraft.turtle_spawn_egg": "ᵷᵷǝ uʍɐds ǝꞁʇɹn⟘",
  "item.minecraft.vex_spawn_egg": "ᵷᵷǝ uʍɐds xǝʌ",
  "item.minecraft.villager_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝᵷɐꞁꞁᴉʌ",
  "item.minecraft.vindicator_spawn_egg": "ᵷᵷǝ uʍɐds ɹoʇɐɔᴉpuᴉʌ",
  "item.minecraft.wandering_trader_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝpɐɹ⊥ ᵷuıɹǝpuɐm",
  "item.minecraft.witch_spawn_egg": "ᵷᵷǝ uʍɐds ɥɔʇᴉm",
  "item.minecraft.wither_skeleton_spawn_egg": "ᵷᵷǝ uʍɐds uoʇǝꞁǝʞs ɹǝɥʇᴉm",
  "item.minecraft.wolf_spawn_egg": "ᵷᵷǝ uʍɐds ɟꞁom",
  "item.minecraft.zoglin_spawn_egg": "ᵷᵷǝ uʍɐds uᴉꞁᵷoz",
  "item.minecraft.zombie_spawn_egg": "ᵷᵷǝ uʍɐds ǝᴉqɯoz",
  "item.minecraft.zombie_horse_spawn_egg": "ᵷᵷǝ uʍɐds ǝsɹoh ǝᴉqɯoz",
  "item.minecraft.zombie_villager_spawn_egg": "ᵷᵷǝ uʍɐds ɹǝᵷɐꞁꞁᴉʌ ǝᴉqɯoz",
  "item.minecraft.zombified_piglin_spawn_egg": "ᵷᵷǝ uʍɐds uᴉꞁᵷᴉԁ pǝᴉɟᴉqɯoz",
  "item.minecraft.experience_bottle": "ᵷuᴉʇuɐɥɔuǝ ,o ǝꞁʇʇoᗺ",
  "item.minecraft.fire_charge": "ǝᵷɹɐɥɔ ǝɹᴉⅎ",
  "item.minecraft.writable_book": "ꞁꞁᴉnꝺ puɐ ʞooᗺ",
  "item.minecraft.written_book": "ʞooᗺ uǝʇʇᴉɹm",
  "item.minecraft.emerald": "pꞁɐɹǝɯǝ",
  "item.minecraft.item_frame": "ǝɯɐɹⅎ ɯǝʇi",
  "block.minecraft.flower_pot": "ʇoԁ ɹǝʍoꞁⅎ",
  "item.minecraft.carrot": "ʇoɹɹɐɔ",
  "item.minecraft.potato": "oʇɐʇoԁ",
  "item.minecraft.baked_potato": "oʇɐʇoԁ ʇǝʞɔɐր",
  "item.minecraft.poisonous_potato": "oʇɐʇoԁ snouosᴉoԁ",
  "item.minecraft.map": "dɐw ʎʇdɯǝ",
  "item.minecraft.golden_carrot": "ʇoɹɹɐɔ uǝpꞁo⅁",
  "block.minecraft.skeleton_skull": "ꞁꞁnʞs uoʇǝꞁǝʞs",
  "block.minecraft.wither_skeleton_skull": "ꞁꞁnʞs uoʇǝꞁǝʞs ɹǝɥʇᴉm",
  "block.minecraft.player_head": "pɐǝh ɹǝʎɐꞁԁ",
  "block.minecraft.zombie_head": "pɐǝh ǝᴉqɯoz",
  "block.minecraft.creeper_head": "pɐǝh ɹǝdǝǝɹɔ",
  "block.minecraft.dragon_head": "pɐǝh uoᵷɐɹᗡ",
  "item.minecraft.carrot_on_a_stick": "ʞɔᴉʇs ɐ uo ʇoɹɹɐɔ",
  "item.minecraft.warped_fungus_on_a_stick": "ʞɔᴉʇs ɐ uo snᵷunⅎ pǝdɹɐm",
  "item.minecraft.nether_star": "ɹɐʇs ɹǝɥʇǝn",
  "item.minecraft.pumpkin_pie": "ǝᴉԁ uᴉʞdɯnԁ",
  "item.minecraft.firework_rocket": "ʇǝʞɔoᴚ ʞɹoʍǝɹᴉⅎ",
  "item.minecraft.firework_star": "ɹɐʇs ʞɹoʍǝɹᴉⅎ",
  "item.minecraft.enchanted_book": "ʞooᗺ pǝʇuɐɥɔuǝ",
  "item.minecraft.nether_brick": "ʞɔᴉɹᗺ ɹǝɥʇǝn",
  "item.minecraft.quartz": "zʇɹɐnꝺ ɹǝɥʇǝn",
  "item.minecraft.tnt_minecart": "⟘n⟘ ɥʇᴉʍ ʇɹɐɔǝuᴉw",
  "item.minecraft.hopper_minecart": "ɹǝddoh ɥʇᴉʍ ʇɹɐɔǝuᴉw",
  "item.minecraft.prismarine_shard": "pɹɐɥs ǝuᴉɹɐɯsᴉɹԁ",
  "item.minecraft.prismarine_crystals": "sꞁɐʇsʎɹɔ ǝuᴉɹɐɯsᴉɹԁ",
  "item.minecraft.rabbit": "ʇᴉqqɐᴚ ʍɐᴚ",
  "item.minecraft.cooked_rabbit": "ʇᴉqqɐᴚ pǝʞooɔ",
  "item.minecraft.rabbit_stew": "ʍǝʇs ʇᴉqqɐᴚ",
  "item.minecraft.rabbit_foot": "ʇooⅎ s,ʇᴉqqɐᴚ",
  "item.minecraft.rabbit_hide": "ǝpᴉh ʇᴉqqɐᴚ",
  "item.minecraft.armor_stand": "puɐʇs ɹnoɯɹɐ",
  "item.minecraft.iron_horse_armor": "ɹnoɯɹɐ ǝsɹoh uoɹi",
  "item.minecraft.golden_horse_armor": "ɹnoɯɹɐ ǝsɹoh uǝpꞁo⅁",
  "item.minecraft.diamond_horse_armor": "ɹnoɯɹɐ ǝsɹoh puoɯɐᴉᗡ",
  "item.minecraft.leather_horse_armor": "ɹnoɯɹɐ ǝsɹoh ɹǝɥʇɐǝꞁ",
  "item.minecraft.lead": "pɐǝꞁ",
  "item.minecraft.name_tag": "ᵷɐ⟘ ǝɯɐn",
  "item.minecraft.command_block_minecart": "ʞɔoꞁᗺ puɐɯɯoɔ ɥʇᴉʍ ʇɹɐɔǝuᴉw",
  "item.minecraft.mutton": "uoʇʇnw ʍɐᴚ",
  "item.minecraft.cooked_mutton": "uoʇʇnw pǝʞooɔ",
  "block.minecraft.white_banner": "ɹǝuuɐᗺ ǝʇᴉɥm",
  "block.minecraft.orange_banner": "ɹǝuuɐᗺ ǝᵷuɐɹo",
  "block.minecraft.magenta_banner": "ɹǝuuɐᗺ ɐʇuǝᵷɐw",
  "block.minecraft.light_blue_banner": "ɹǝuuɐᗺ ǝnꞁᗺ ʇɥᵷᴉꞁ",
  "block.minecraft.yellow_banner": "ɹǝuuɐᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.lime_banner": "ɹǝuuɐᗺ ǝɯᴉꞁ",
  "block.minecraft.pink_banner": "ɹǝuuɐᗺ ʞuᴉԁ",
  "block.minecraft.gray_banner": "ɹǝuuɐᗺ ʎǝɹ⅁",
  "block.minecraft.light_gray_banner": "ɹǝuuɐᗺ ʎǝɹ⅁ ʇɥᵷᴉꞁ",
  "block.minecraft.cyan_banner": "ɹǝuuɐᗺ uɐʎɔ",
  "block.minecraft.purple_banner": "ɹǝuuɐᗺ ǝꞁdɹnԁ",
  "block.minecraft.blue_banner": "ɹǝuuɐᗺ ǝnꞁᗺ",
  "block.minecraft.brown_banner": "ɹǝuuɐᗺ uʍoɹᗺ",
  "block.minecraft.green_banner": "ɹǝuuɐᗺ uǝǝɹ⅁",
  "block.minecraft.red_banner": "ɹǝuuɐᗺ pǝᴚ",
  "block.minecraft.black_banner": "ɹǝuuɐᗺ ʞɔɐꞁᗺ",
  "item.minecraft.end_crystal": "ꞁɐʇsʎɹɔ puǝ",
  "item.minecraft.chorus_fruit": "ʇᴉnɹⅎ snɹoɥɔ",
  "item.minecraft.popped_chorus_fruit": "ʇᴉnɹⅎ snɹoɥɔ pǝddoԁ",
  "item.minecraft.beetroot": "ʇooɹʇǝǝᗺ",
  "item.minecraft.beetroot_seeds": "spǝǝs ʇooɹʇǝǝᗺ",
  "item.minecraft.beetroot_soup": "dnos ʇooɹʇǝǝᗺ",
  "item.minecraft.dragon_breath": "ɥʇɐǝɹᗺ s,uoᵷɐɹᗡ",
  "item.minecraft.splash_potion": "uoᴉʇoԁ ǝꞁqɐʇɟɐɹɔu∩ ɥsɐꞁds□sʇɔǝɟɟǝ on",
  "item.minecraft.spectral_arrow": "ʍoɹɹɐ ꞁɐɹʇɔǝds",
  "item.minecraft.tipped_arrow": "ʍoɹɹɐ pǝddᴉ⟘ ǝꞁqɐʇɟɐɹɔu∩□sʇɔǝɟɟǝ on",
  "item.minecraft.lingering_potion": "uoᴉʇoԁ ǝꞁqɐʇɟɐɹɔu∩ ᵷuᴉɹǝᵷuᴉꞁ□sʇɔǝɟɟǝ on",
  "item.minecraft.shield": "pꞁǝᴉɥs",
  "item.minecraft.elytra": "ɐɹʇʎꞁǝ",
  "item.minecraft.spruce_boat": "ʇɐoᗺ ǝɔnɹds",
  "item.minecraft.birch_boat": "ʇɐoᗺ ɥɔɹᴉᗺ",
  "item.minecraft.jungle_boat": "ʇɐoᗺ ǝꞁᵷunր",
  "item.minecraft.acacia_boat": "ʇɐoᗺ ɐᴉɔɐɔɐ",
  "item.minecraft.dark_oak_boat": "ʇɐoᗺ ʞɐo ʞɹɐᗡ",
  "item.minecraft.totem_of_undying": "ᵷuᴉʎpu∩ ɟo ɯǝʇo⟘",
  "item.minecraft.shulker_shell": "ꞁꞁǝɥs ɹǝʞꞁnɥs",
  "item.minecraft.iron_nugget": "ʇǝᵷᵷnn uoɹi",
  "item.minecraft.knowledge_book": "ʞooᗺ ǝᵷpǝꞁʍouʞ",
  "item.minecraft.debug_stick": "ʞɔᴉʇs ᵷnqǝᗡ",
  "item.minecraft.music_disc_13": "ɔsᴉᗡ ɔᴉsnw□ɛ⥝ - 8⥝߈ɔ",
  "item.minecraft.music_disc_cat": "ɔsᴉᗡ ɔᴉsnw□ʇɐɔ - 8⥝߈ɔ",
  "item.minecraft.music_disc_blocks": "ɔsᴉᗡ ɔᴉsnw□sʞɔoꞁq - 8⥝߈ɔ",
  "item.minecraft.music_disc_chirp": "ɔsᴉᗡ ɔᴉsnw□dɹᴉɥɔ - 8⥝߈ɔ",
  "item.minecraft.music_disc_far": "ɔsᴉᗡ ɔᴉsnw□ɹɐɟ - 8⥝߈ɔ",
  "item.minecraft.music_disc_mall": "ɔsᴉᗡ ɔᴉsnw□ꞁꞁɐɯ - 8⥝߈ɔ",
  "item.minecraft.music_disc_mellohi": "ɔsᴉᗡ ɔᴉsnw□ᴉɥoꞁꞁǝɯ - 8⥝߈ɔ",
  "item.minecraft.music_disc_stal": "ɔsᴉᗡ ɔᴉsnw□ꞁɐʇs - 8⥝߈ɔ",
  "item.minecraft.music_disc_strad": "ɔsᴉᗡ ɔᴉsnw□pɐɹʇs - 8⥝߈ɔ",
  "item.minecraft.music_disc_ward": "ɔsᴉᗡ ɔᴉsnw□pɹɐʍ - 8⥝߈ɔ",
  "item.minecraft.music_disc_11": "ɔsᴉᗡ ɔᴉsnw□⥝⥝ - 8⥝߈ɔ",
  "item.minecraft.music_disc_wait": "ɔsᴉᗡ ɔᴉsnw□ʇᴉɐʍ - 8⥝߈ɔ",
  "item.minecraft.music_disc_pigstep": "ɔsᴉᗡ ɔᴉsnw□dǝʇsᵷᴉԁ - ǝuᴉɐᴚ ɐuǝꞁ",
  "item.minecraft.trident": "ʇuǝpᴉɹ⟘□□:puɐh uᴉɐw uᴉ uǝɥm□ǝᵷɐɯɐᗡ ʞɔɐʇʇɐ 8+□pǝǝds ʞɔɐʇʇɐ 2.9-",
  "item.minecraft.phantom_membrane": "ǝuɐɹqɯǝw ɯoʇuɐɥԁ",
  "item.minecraft.nautilus_shell": "ꞁꞁǝɥs snꞁᴉʇnɐn",
  "item.minecraft.heart_of_the_sea": "ɐǝs ǝɥʇ ɟo ʇɹɐǝh",
  "item.minecraft.crossbow": "ʍoqssoɹɔ",
  "item.minecraft.suspicious_stew": "ʍǝʇs snoᴉɔᴉdsns",
  "block.minecraft.loom": "ɯooꞁ",
  "item.minecraft.flower_banner_pattern": "uɹǝʇʇɐԁ ɹǝuuɐᗺ□ǝᵷɹɐɥɔ ɹǝʍoꞁⅎ",
  "item.minecraft.creeper_banner_pattern": "uɹǝʇʇɐԁ ɹǝuuɐᗺ□ǝᵷɹɐɥɔ ɹǝdǝǝɹɔ",
  "item.minecraft.skull_banner_pattern": "uɹǝʇʇɐԁ ɹǝuuɐᗺ□ǝᵷɹɐɥɔ ꞁꞁnʞs",
  "item.minecraft.mojang_banner_pattern": "uɹǝʇʇɐԁ ɹǝuuɐᗺ□ᵷuᴉɥ⟘",
  "item.minecraft.globe_banner_pattern": "uɹǝʇʇɐԁ ɹǝuuɐᗺ□ǝqoꞁ⅁",
  "item.minecraft.piglin_banner_pattern": "uɹǝʇʇɐԁ ɹǝuuɐᗺ□ʇnous",
  "block.minecraft.composter": "ɹǝʇsodɯoɔ",
  "block.minecraft.barrel": "ꞁǝɹɹɐᗺ",
  "block.minecraft.smoker": "ɹǝʞoɯs",
  "block.minecraft.blast_furnace": "ǝɔɐuɹnⅎ ʇsɐꞁᗺ",
  "block.minecraft.cartography_table": "ǝlqɐ⟘ ʎɥdɐɹᵷoʇɹɐɔ",
  "block.minecraft.fletching_table": "ǝlqɐ⟘ ᵷuᴉɥɔʇǝlⅎ",
  "block.minecraft.grindstone": "ǝuoʇspuᴉɹ⅁",
  "block.minecraft.lectern": "uɹǝʇɔǝꞁ",
  "block.minecraft.smithing_table": "ǝlqɐ⟘ ᵷuᴉɥʇᴉɯs",
  "block.minecraft.stonecutter": "ɹǝʇʇnɔǝuoʇs",
  "block.minecraft.bell": "ꞁꞁǝᗺ",
  "block.minecraft.lantern": "uɹǝʇuɐꞁ",
  "block.minecraft.soul_lantern": "uɹǝʇuɐꞁ ꞁnos",
  "item.minecraft.sweet_berries": "sǝᴉɹɹǝᗺ ʇǝǝʍs",
  "block.minecraft.campfire": "ǝɹᴉɟdɯɐɔ",
  "block.minecraft.soul_campfire": "ǝɹᴉɟdɯɐɔ ꞁnos",
  "block.minecraft.shroomlight": "ʇɥᵷᴉꞁɯooɹɥs",
  "item.minecraft.honeycomb": "qɯoɔʎǝuoh",
  "block.minecraft.bee_nest": "ʇsǝn ǝǝᗺ",
  "block.minecraft.beehive": "ǝʌᴉɥǝǝᗺ",
  "item.minecraft.honey_bottle": "ǝꞁʇʇoᗺ ʎǝuoh",
  "block.minecraft.honey_block": "ʞɔoꞁᗺ ʎǝuoh",
  "block.minecraft.honeycomb_block": "ʞɔoꞁᗺ qɯoɔʎǝuoh",
  "block.minecraft.lodestone": "ǝuoʇsǝpoꞁ",
  "block.minecraft.netherite_block": "ǝʇᴉɹǝɥʇǝn ɟo ʞɔoꞁᗺ",
  "block.minecraft.ancient_debris": "sᴉɹqǝᗡ ʇuǝᴉɔuɐ",
  "block.minecraft.target": "ʇǝᵷɹɐ⟘",
  "block.minecraft.crying_obsidian": "uɐᴉpᴉsqo ᵷuᴉʎɹɔ",
  "block.minecraft.blackstone": "ǝuoʇsʞɔɐꞁᗺ",
  "block.minecraft.blackstone_slab": "qɐꞁs ǝuoʇsʞɔɐꞁᗺ",
  "block.minecraft.blackstone_stairs": "sɹᴉɐʇs ǝuoʇsʞɔɐꞁᗺ",
  "block.minecraft.gilded_blackstone": "ǝuoʇsʞɔɐꞁᗺ pǝpꞁᴉ⅁",
  "block.minecraft.polished_blackstone": "ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.polished_blackstone_slab": "qɐꞁs ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.polished_blackstone_stairs": "sɹᴉɐʇs ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.chiseled_polished_blackstone": "ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ pǝꞁꞁǝsᴉɥɔ",
  "block.minecraft.polished_blackstone_bricks": "sʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.polished_blackstone_brick_slab": "qɐꞁs ʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.polished_blackstone_brick_stairs": "sɹᴉɐʇs ʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ",
  "block.minecraft.cracked_polished_blackstone_bricks": "sʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԁ pǝʞɔɐɹɔ",
  "block.minecraft.respawn_anchor": "ɹoɥɔuɐ uʍɐdsǝᴚ",
}
export const en_ud = items; 
